module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BookItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BookItalic.eot
 ** module id = 345
 ** module chunks = 0
 **/